import { Coverage } from '../coverage';
import { Policy } from '../policy';

export interface WarrantyCoverage {
  coverageId: string;
  coverage?: Coverage.Model;

  requirement: Policy.Plan.CoverageRequirement;
  price: number;
  liabilityLimit: number;
  deductible: number;
  liabilityGroups: string[];
  liabilityGroupObjects?: Policy.Plan.LiabilityGroup[];

  /**
   * Set when a previously-paid coverage isn't renewed (dropped by the customer, or no longer
   * offered by the policy) — the customer already paid through the warranty's pre-renewal expiry
   * date, so the coverage stays honored until then instead of vanishing the instant renewal is
   * confirmed. Null/undefined means the coverage has no such grandfathered cutoff.
   */
  activeUntil?: Date | null;
}

/**
 * A coverage is considered included if it exists, is not marked as NOT_APPLICABLE, and (for a
 * grandfathered coverage carried over from a renewal it wasn't re-selected for) its paid-through
 * `activeUntil` date hasn't passed yet.
 */
export function isCoverageIncluded(coverage: WarrantyCoverage | undefined, asOf: Date = new Date()): boolean {
  if (coverage === undefined) return false;
  if (coverage.requirement === Policy.Plan.CoverageRequirementValue.NOT_APPLICABLE) return false;
  if (coverage.activeUntil && new Date(coverage.activeUntil).getTime() < asOf.getTime()) return false;
  return true;
}
